const moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(9943), __webpack_require__.e(8552), __webpack_require__.e(7507), __webpack_require__.e(9945), __webpack_require__.e(9249), __webpack_require__.e(425), __webpack_require__.e(2995), __webpack_require__.e(3444), __webpack_require__.e(3758), __webpack_require__.e(6717), __webpack_require__.e(1975), __webpack_require__.e(7664), __webpack_require__.e(4007), __webpack_require__.e(2904), __webpack_require__.e(1682), __webpack_require__.e(8935), __webpack_require__.e(7449)]).then(() => (() => ((__webpack_require__(56974)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});